import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import './style.scss';
import { useSignUpMutation } from '../../api/accountApi';

const SignUpPage = (props) => {
    const navigate = useNavigate();
    const [register] = useSignUpMutation();
    const [loader,setLoader] = useState(false);
    const [value, setValue] = useState({
        email: '',
        full_name: '',
        userName: '',
        phoneNumber: '',
        password: '',
        confirm_password: '',
        role: 'Student'
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };


    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage',
        validators: {
            matchPassword: {  // Custom validator
                message: 'Passwords do not match.',
                rule: (val, params, validator) => {
                    return val !== value.password;
                },
                required: true
            }
        }
    }));

    const changeHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        validator.showMessages();
    };
    

    const submitForm = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {

            if (value.password !== value.confirm_password) {
                alert("The selected confirm password must be password.")
                return;
            }

            setLoader(true);

            await register({
                userName: value.userName,
                fullName: value.full_name,
                email: value.email,
                phoneNumber: value.phoneNumber,
                password: value.password,
                confirmPassword: value.confirm_password,
                role: value.role
            }).then((response) => {
                setLoader(false);

                // Handle successful registration
                if (response.data && response.data.isSuccess) {
                    validator.hideMessages();
                    toast.success('Please Check Your Email Address For Verification. If You Don\'t Find It, Check Your Spam Folder.');
                    navigate('/login');
                }
                // Handle validation errors from backend
                else if (response.data && response.data.errorMessages && response.data.errorMessages.length > 0) {
                    // Display all error messages
                    response.data.errorMessages.forEach((errorMsg, index) => {
                        setTimeout(() => {
                            toast.error(errorMsg);
                        }, index * 100); // Stagger the toasts slightly for better visibility
                    });
                }
                // Handle API errors (network, server errors, etc.)
                else if (response.error) {
                    if (response.error.data && response.error.data.errorMessages && response.error.data.errorMessages.length > 0) {
                        response.error.data.errorMessages.forEach((errorMsg, index) => {
                            setTimeout(() => {
                                toast.error(errorMsg);
                            }, index * 100);
                        });
                    } else if (response.error.data && response.error.data.message) {
                        toast.error(response.error.data.message);
                    } else {
                        toast.error('Registration failed. Please try again.');
                    }
                }
                // Generic error
                else {
                    toast.error('Something went wrong. Please try again.');
                }
            }).catch((error) => {
                setLoader(false);
                console.error('Registration error:', error);
                toast.error('An unexpected error occurred. Please try again.');
            });
        } else {
            validator.showMessages();
            toast.error('Empty field is not allowed!');
        }
    };

    return (
        <Grid className="loginWrapper">
            <Grid className="loginForm">
                <h2>Signup</h2>
                <p>Signup your account</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Full Name"
                                value={value.full_name}
                                variant="outlined"
                                name="full_name"
                                label="Name"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('full_name', value.full_name, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="E-mail"
                                value={value.email}
                                variant="outlined"
                                name="email"
                                label="E-mail"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('email', value.email, 'required|email')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Username"
                                value={value.userName}
                                variant="outlined"
                                name="userName"
                                label="Username"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('userName', value.userName, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Phone Number"
                                value={value.phoneNumber}
                                variant="outlined"
                                name="phoneNumber"
                                label="Phone Number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('phoneNumber', value.phoneNumber, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ position: 'relative' }}>
                                <TextField
                                    className="inputOutline"
                                    type={showPassword ? "text" : "password"}
                                    fullWidth
                                    placeholder="Password"
                                    value={value.password}
                                    variant="outlined"
                                    name="password"
                                    label="Password"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={(e) => changeHandler(e)}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <span
                                    onClick={handleClickShowPassword}
                                    style={{
                                        position: 'absolute',
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#8d4e2f',
                                        userSelect: 'none',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#2f4f40'}
                                    onMouseLeave={(e) => e.target.style.color = '#8d4e2f'}
                                >
                                    {showPassword ? 'HIDE' : 'SHOW'}
                                </span>
                            </div>
                            {validator.message('password', value.password, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ position: 'relative' }}>
                                <TextField
                                    className="inputOutline"
                                    fullWidth
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    value={value.confirm_password}
                                    variant="outlined"
                                    name="confirm_password"
                                    label="Confirm Password"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onBlur={(e) => changeHandler(e)}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <span
                                    onClick={handleClickShowConfirmPassword}
                                    style={{
                                        position: 'absolute',
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#8d4e2f',
                                        userSelect: 'none',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#2f4f40'}
                                    onMouseLeave={(e) => e.target.style.color = '#8d4e2f'}
                                >
                                    {showConfirmPassword ? 'HIDE' : 'SHOW'}
                                </span>
                            </div>
                            {validator.message('confirm_password', value.confirm_password, 'required|matchPassword')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth disabled={loader} className="cBtn cBtnLarge cBtnTheme" type="submit">
                                    
                                {loader ? <Spinner animation="border" sx={{ marginTop: '10px', textAlign: 'center' }} />: "Sign Up" }
                                    
                                    
                                    
                                    </Button>
                            </Grid>
                            <p className="noteHelp">Already have an account? <Link to="/login">Return to Sign In</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default SignUpPage;
